import React, { Component } from 'react';
import Filter from './Filter';
import authUtils from '../../../auth/utils';
import utils from '../../../common/services/utils';
import ui from '../../../common/services/ui';
import { filterPrograms } from '../modes/common';
import EditWeeklyProgram from '../modes/EditWeeklyProgram';
import { withTranslation } from 'react-i18next';
import { Alert } from 'react-bootstrap';
import Spinner from '../../../common/components/Spinner';
import OneOffProgram, { OneOffProgramMode } from '../modes/OneOffProgram';


class WeeklyProgramCalendar extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleWeeklyProgramItemClick = this.handleWeeklyProgramItemClick.bind(this);
		this.handleRenderChildCount = this.handleRenderChildCount.bind(this);
		this.handleTermSelected = this.handleTermSelected.bind(this);
		this.handleCenterSelected = this.handleCenterSelected.bind(this);
		this.initialFilterSet = false;

		this.state = {
			termId: null,
			centerId: null
		};
	}

	componentDidMount() {
		if (!this.initialFilterSet) {
			const { weeklyProgramFilter, initializeFilter } = this.props;
			const hasFilter = this.hasFilter(weeklyProgramFilter.filter);
			if (hasFilter) {
				this.initialFilterSet = true;
				// Initializes filter from state in redux
				initializeFilter('ChildAttendanceFilter', weeklyProgramFilter.filter);
				this.loadData({ filter: weeklyProgramFilter.filter });
			}
		}
	}

	componentDidUpdate() {
		// fired after state is updated in handleTermSelected or handleCenterSelected

		// trigger filter on initial load when default values are selected in the Terms and Centers dropdowns
		if (!this.initialFilterSet) {
			// If filter is not set in componentDidMount, then filter does not have state in redux
			// and we initialize it with default values
			this.setInitialFilter();
		}
	}

	hasFilter(filter) {
		if (filter) {
			const { termId, centerId } = filter;
			return termId || centerId;
		}

		return false;
	}

	setInitialFilter() {
		const { initializeFilter } = this.props;
		const { termId, centerId } = this.state;
		if (termId && centerId) {
			this.initialFilterSet = true;

			initializeFilter('ChildAttendanceFilter', { termId, centerId });
			this.loadData({ filter: { termId, centerId } });
		}
	}

	loadData({ filter }) {
		const { loadWeeklyProgram } = this.props;
		loadWeeklyProgram({ ...filter });
	}

	handleWeeklyProgramItemClick(day, weeklyProgramItem) {
		const { onWeeklyProgramItemClick } = this.props;
		if (onWeeklyProgramItemClick) {
			onWeeklyProgramItemClick(day, weeklyProgramItem);
		}
	}

	handleTermSelected(termId) {
		this.setState({ termId });
	}

	handleCenterSelected(centerId) {
		this.setState({ centerId });
	}

	handleFilterSubmit(filter) {
		this.loadData({ filter });
	}

	handleRenderChildCount(weeklyProgramItem) {
		const { t, enableTrials, enableMakeUps } = this.props;
		const { maxChildrenRest, maxTrialChildrenRest, maxMakeUpChildrenRest, attendingChildrenCount, attendingTrialChildrenCount, attendingMakeUpChildrenCount, attendingTrialReservation, attendanceDate } = weeklyProgramItem;
		const normalCount = `${attendingChildrenCount || 0}/${maxChildrenRest || 0} ${t('LessonAttendance_NormalCount')}`;
		const trialReservationCount = `${attendingTrialReservation || 0} ${t('LessonAttendance_TrialReservationCount', { count: attendingTrialReservation || 0 })}`;
		const trialCount = `${attendingTrialChildrenCount || 0}/${maxTrialChildrenRest || 0} ${t('LessonAttendance_TrialCount')}`;
		const makeUpCount = `${attendingMakeUpChildrenCount || 0}/${maxMakeUpChildrenRest || 0} ${t('LessonAttendance_MakeUpCount')}`;
		// the counts are for a single lesson date, which is not necessarily in the current week (holidays)
		const countsForDate = attendanceDate ? t('LessonAttendance_CountsForDate', { date: ui.customDateFormat(attendanceDate, 'LL') }) : undefined;
		return <span title={countsForDate}>
			{normalCount}{attendingTrialReservation > 0 ? `, ${trialReservationCount}` : ''}
			{enableTrials && <br />}
			{enableTrials && trialCount}
			{enableMakeUps && <br />}
			{enableMakeUps && makeUpCount}
		</span>;
	}

	renderWeeklyProgram() {
		const { isReadOnly, currentUser, t, weeklyProgramFilter, showAvailabilityColor, showSeparateSingleLessons,
			enableTrials, enableMakeUps, timetableViewType } = this.props;
		const canView = authUtils.hasPermission(currentUser, 'WeeklyPrograms'); // Full access or read only - in either case can view the weekly program
		if (canView) {
			const { weeklyPrograms, terms, centers } = this.props;
			const { centerId, termId } = weeklyProgramFilter.filter;
			const weeklyProgram = filterPrograms(weeklyPrograms, centerId, termId);
			return (<div>
				<EditWeeklyProgram
					onEdit={this.handleWeeklyProgramItemClick}
					weeklyPrograms={showSeparateSingleLessons ? utils.filter(weeklyProgram, p => p.status == 1) : weeklyProgram}
					center={centers[centerId]}
					term={terms[termId]}
					t={t}
					hideButtons
					hideChildCount
					onRenderChildCount={this.handleRenderChildCount}
					headerResource={'MoveLesson_SelectProgramHeader'}
					showAvailabilityColor={showAvailabilityColor}
					enableTrials={enableTrials}
					enableMakeUps={enableMakeUps}
					timetableViewType={timetableViewType}
				/>
				{showSeparateSingleLessons && <OneOffProgram
					data={weeklyProgram.filter(p => p.status == 4)}
					headerLabel={t('WeeklyProgram_SingleLessons')}
					onEdit={this.handleWeeklyProgramItemClick}
					mode={OneOffProgramMode.ATTENDANCE}
					t={t}
					center={centers[centerId]}
					term={terms[termId]}
					isReadOnly={isReadOnly}
					enableTrials={enableTrials}
					enableMakeUps={enableMakeUps}
					timetableViewType={timetableViewType}
				/>}
			</div>
			);
		}

		return (
			<Alert bsStyle='warning'>
				<strong>{`${t('Common_PermissionError')}!`}</strong> {`${t('PermissionError_WeeklyProgramReadRight')}.`}
			</Alert>
		);
	}

	render() {
		const { isReadOnly, t, weeklyProgramFilter, kindergarten, filterHeading } = this.props;
		const weeklyProgram = this.renderWeeklyProgram();

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					onFilterInitialUpdate={this.handleFilterInitialUpdate}
					onTermSelected={this.handleTermSelected}
					onCenterSelected={this.handleCenterSelected}
					kindergarten={kindergarten}
					heading={filterHeading}
					t={t}
				/>
				{
					weeklyProgramFilter.loading ? (
						<Spinner />
					) : (
						weeklyProgram
					)
				}
			</div>
		);
	}
}

export default withTranslation()(WeeklyProgramCalendar);